import { render } from "./ProfesionalesListado.vue?vue&type=template&id=f75a2066&ts=true"
import script from "./ProfesionalesListado.vue?vue&type=script&lang=ts"
export * from "./ProfesionalesListado.vue?vue&type=script&lang=ts"

import "./ProfesionalesListado.vue?vue&type=style&index=0&id=f75a2066&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__